export default __webpack_public_path__ + "static/media/10.ed99ec3b.PNG";